/**
 * Finds and returns value from URL Search Params
 * @param {string | string[]} parameter - one or more search params to be queried
 * @returns {string} - found value or empty string
 */
function qs(parameter) {
  const searchParams = new URLSearchParams(window.location.search)
  if (typeof parameter === 'string') {
    return searchParams.get(parameter) ?? ''
  }

  return parameter.map(key => searchParams.get(key)).find(value => value !== null) ?? ''
}

export { qs }
